#topContainer {
  background-color: #4492cf;
  height: 50vh;
  align-items: center;
}
